module.exports = {
  // People Popup
  ACTION_OPEN_POPUP: 'ACTION_OPEN_POPUP',
  ACTION_CLOSE_POPUP: 'ACTION_CLOSE_POPUP',
  ACTION_NAVIGATE_RIGHT: 'ACTION_NAVIGATE_RIGHT',
  ACTION_NAVIGATE_LEFT: 'ACTION_NAVIGATE_LEFT',
  EVENT_POPULATE_POPUP: 'EVENT_POPULATE_POPUP',
  EVENT_OPEN_POPUP: 'EVENT_OPEN_POPUP',
  EVENT_CLOSE_POPUP: 'EVENT_CLOSE_POPUP',
  EVENT_UPDATE_PERSON: 'EVENT_UPDATE_PERSON',

  // News Panel
  ACTION_OPEN_NEWS: 'ACTION_OPEN_NEWS',
  ACTION_CLOSE_NEWS: 'ACTION_CLOSE_NEWS'
}
